import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../store/api/rx-factory'
import * as Enpoints from '../../../../store/api/endpoints'
import * as COMMON from '../../../../store/commomFunction'
import moment from 'moment'
export const actions = {
    [Const.RUN_GET_BANK_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_BANK_DETAILS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            // result.res_data = []
            if (!error) {

                if(credentials.localParams.pagename == 'withdrawalFiat'){
                    if(result.res_data.totalRecords > 0){
                        credentials.localParams.parameter.selected_method =  result.res_data.records[0]
                        credentials.localParams.parameter.methodId = result.res_data.records[0].id
                    }else{
                        credentials.localParams.parameter.selected_method =  {}
                        credentials.localParams.parameter.methodId = ''
                    }
                }
                commit(Const.SET_BANK_DETAILS, result.res_data)
            } else {
                if(credentials.localParams.pagename == 'withdrawalFiat'){
                    credentials.localParams.parameter.selected_method =  {}
                    credentials.localParams.parameter.methodId = ''
                }
                commit(Const.SET_BANK_DETAILS, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_ADD_BANK_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ADD_BANK_DETAILS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'Add Bank Successfully', 'success')
                credentials.localParams.parameter.reset()
                if(credentials.localParams.pagename == 'settings'){
                    credentials.localParams.parameter.$parent.addBankModal = false
                    dispatch(Const.RUN_GET_BANK_DETAILS, { 'globalParams': {}, 'localParams': { 'parameter': credentials.localParams.parameter }});
                }else if(credentials.localParams.pagename == 'withdrawalFiat'){
                    credentials.localParams.parameter.$router.push({ path: '/settings', query: { 'settingTab': 'bankinfo' } })
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_Edit_BANK_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_Edit_BANK_DETAILS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {

                if(credentials.localParams.pagename == 'bankList'){
                    credentials.localParams.parameter.$parent.editBank = {}
                }else if(credentials.localParams.pagename == 'withdrawalFiat'){
                    credentials.localParams.parameter.$parent.modal = 'eur-withdrawal-accounts'
                    credentials.localParams.parameter.$parent.editBankData = {}
                }

                dispatch(Const.RUN_GET_BANK_DETAILS, { 'globalParams': {}, 'localParams': { 'parameter': credentials.localParams.parameter }});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'edit payment method Successfully', 'success')
                credentials.localParams.parameter.reset()
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_DELETE_PAYMENT_METHOD]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_RUN_DELETE_PAYMENT_METHOD, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {

                if(credentials.localParams.pagename == 'bankList'){
                    credentials.localParams.parameter.$parent.deleteBank = {}
                    dispatch(Const.RUN_GET_BANK_DETAILS, { 'globalParams': {}, 'localParams': { 'parameter': credentials.localParams.parameter }});
                }else if(credentials.localParams.pagename == 'withdrawalFiat'){
                    credentials.localParams.parameter.$parent.modal = 'eur-withdrawal-accounts'
                    credentials.localParams.parameter.$parent.deleteBankData = {}
                    credentials.localParams.parameter.$parent.getBankDetails()
                }
                
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'delete payment method Successfully', 'success')
                credentials.localParams.parameter.reset()
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_FIAT_WITHDRAWAL_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_RUN_FIAT_WITHDRAWAL_REQUEST_OTP, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // COMMON._messageDisplayFunction('Add Bank Successfully', result.res_data, 'success')
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_FIAT_WITHDRAWAL_REQUEST_RESEND_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_FIAT_WITHDRAWAL_REQUEST_RESEND_OTP, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'otp resend Successfully', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_FIAT_WITHDRAWAL_REQUEST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_RUN_FIAT_WITHDRAWAL_REQUEST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.$parent.withdrawalListing(credentials.localParams.account_id)
                credentials.localParams.parameter.modal = 'confirm_withdrawal_success'
                credentials.localParams.parameter.reset()
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    


    //deposit list
    [Const.RUN_GET_DEPOSIT_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_DEPOSIT_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if(credentials.localParams.pageFlag == 'download'){
                    if(result.res_data.records.length > 0){
                        for(let i = 0 ; i<=result.res_data.records.length-1 ; i++){
                            delete result.res_data.records[i].user_id ;
                            delete result.res_data.records[i].account_id ;
                            delete result.res_data.records[i].platform ;
                            delete result.res_data.records[i].conversion_rate ;
                            delete result.res_data.records[i].deposit_type ;
                            delete result.res_data.records[i].deposit_method ;
                            delete result.res_data.records[i].payment_status ;

                            delete result.res_data.records[i].note ;
                            delete result.res_data.records[i].payment_date ;
                            delete result.res_data.records[i].modified ;
                            if(i == result.res_data.records.length-1){
                                credentials.localParams.parameter.downloadData = result.res_data
                                credentials.localParams.parameter.downloadTransactions()
                            }
                        }
                    }else{
                        credentials.localParams.parameter.downloadData = result.res_data
                        credentials.localParams.parameter.downloadTransactions()
                    }
                }else{
                    commit(Const.SET_DEPOSIT_LIST, result.res_data)
                }
            } else {
                if(credentials.localParams.pageFlag == 'download'){
                    credentials.localParams.parameter.downloadData = {}
                    credentials.localParams.parameter.downloadTransactions()
                }else{
                    commit(Const.SET_DEPOSIT_LIST, {})
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_WITHDRAWAL_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WITHDRAWAL_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if(credentials.localParams.pageFlag == 'download'){
                    if(result.res_data.records.length > 0){
                        for(let i = 0 ; i<=result.res_data.records.length-1 ; i++){
                            delete result.res_data.records[i].user_id ;
                            delete result.res_data.records[i].withdrawal_type ;
                            delete result.res_data.records[i].withdrawal_status ;
                            delete result.res_data.records[i].ticket_id ;
                            delete result.res_data.records[i].txn_web ;
                            delete result.res_data.records[i].created ;
                            delete result.res_data.records[i].modified ;
                            if(i == result.res_data.records.length-1){
                                credentials.localParams.parameter.downloadData = result.res_data
                                credentials.localParams.parameter.downloadTransactions()
                            }
                        }
                    }else{
                        credentials.localParams.parameter.downloadData = result.res_data
                        credentials.localParams.parameter.downloadTransactions()
                    }
                }else{
                    commit(Const.SET_WITHDRAWAL_LIST, result.res_data)
                }
            } else {
                if(credentials.localParams.pageFlag == 'download'){
                    credentials.localParams.parameter.downloadData = {}
                    credentials.localParams.parameter.downloadTransactions()
                }else{
                    commit(Const.SET_WITHDRAWAL_LIST, {})
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },


    [Const.RUN_GENERATE_WALLET_ADDRESS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GENERATE_WALLET_ADDRESS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_GENERATE_WALLET_ADDRESS, result.res_data.address)
                if(credentials.localParams.parameter.$route.name == 'crypto_deposit'){
                    credentials.localParams.parameter.regulerDetails()
                }
            } else {
                commit(Const.SET_GENERATE_WALLET_ADDRESS, '')
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    /*[Const.RUN_GET_PAYMENT_METHODS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PAYMENT_METHODS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_PAYMENT_METHODS, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },*/

    [Const.RUN_DEMO_DEPOSIT]({commit, state,getters,dispatch}, credentials){    
        COMMON._executeApi(Enpoints.EP_DEMO_DEPOSIT, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                credentials.localParams.parameter.reset()
                if(credentials.localParams.page == 'man_account'){
                    credentials.localParams.parameter.fund_msz = 'fund_msz'
                    credentials.localParams.parameter.fund_msz_type = 'success'
                }else{
                    COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz17','success')
                }
            }else{
                if(credentials.localParams.page == 'man_account'){
                    credentials.localParams.parameter.fund_msz = result.res_data
                    credentials.localParams.parameter.fund_msz_type = 'error'
                }else{
                    COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
                }
                
            }
        })
    },
    [Const.RUN_TRANS_LIMIT_CURRENCY]({commit, state,getters,dispatch}, credentials){    
        COMMON._executeApi(Enpoints.EP_TRANS_LIMIT_CURRENCY, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                /*console.log(credentials.localParams.parameter.get_method_id)
                console.log(result.res_data[credentials.localParams.parameter.get_method_id])
                console.log(result.res_data[credentials.localParams.parameter.get_method_id].MONTHLY)*/
                if(parseInt(result.res_data[credentials.localParams.parameter.get_method_id].MONTHLY) == 0){
                    credentials.localParams.parameter.raised_max_limit_msg = "you have raised max limit of transaction per month"
                }else{
                    credentials.localParams.parameter.raised_max_limit_msg = ''
                }
                credentials.localParams.parameter.responseTransLimitData =  result.res_data
            }else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        }) 
    },
    [Const.RUN_GET_USER_CAN_DEPOSIT]({commit, state,getters,dispatch}, credentials){    
        COMMON._executeApi(Enpoints.EP_GET_USER_CAN_DEPOSIT, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                commit(Const.SET_DEPOSIT_LIMIT, result.res_data)
            }else{
                commit(Const.SET_DEPOSIT_LIMIT, [])
                //COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        })
    },
    [Const.RUN_CREDIT_CARD_DEPOSIT]({commit, state,getters,dispatch}, credentials){ 
        COMMON._executeApi(Enpoints.EP_CREDIT_CARD_DEPOSIT, credentials, {'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                if(result.res_data.url){
                    window.open(result.res_data.url,'_self');
                }else{
                    credentials.localParams.parameter.transaction_id = result.res_data.transaction_id
                    credentials.localParams.parameter.submitPay(result.res_data.transaction_id);
                }
                    
            }else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        }) 
    },

    [Const.RUN_GET_WITHDRAWAL_METHODS]({commit, state,getters,dispatch}, credentials){  
        COMMON._executeApi(Enpoints.EP_GET_WITHDRAWAL_METHODS, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                //withdrawalMethodResponse
                commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE,  result.res_data)
                let json ={} , count =0 ;
                for(var key in result.res_data){
                    count++
                    json[key] = {}
                    let count1 = 0
                    for(var innerkey in result.res_data[key]){
                        count1++
                        json[key][result.res_data[key][innerkey].id] = result.res_data[key][innerkey]
                        if(count1 == Object.keys(result.res_data[key]).length){
                            // console.log(json)
                        }
                    }
                    if(count == Object.keys(result.res_data).length){
                        commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP,json)
                        commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, json)
                    }
                }
            }else{
                commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP, {})
                commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        })
    },

    [Const.RUN_WITHDRAWAL_REQUEST_OTP]({commit, state,getters,dispatch}, credentials){  
        COMMON._executeApi(Enpoints.EP_WITHDRAWAL_REQUEST_OTP, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                let user_json = getters['GET_USER']
                // console.log('request-otp------->',result.res_data)
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id
                credentials.localParams.parameter.submit = false
            }else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        }) 
    },
    [Const.RUN_WITHDRAWAL_CHECK_OTP]({commit, state,getters,dispatch}, credentials){    
        COMMON._executeApi(Enpoints.EP_WITHDRAWAL_CHECK_OTP, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                if(credentials.localParams.params){
                    credentials.localParams.parameter.success = true
                    //credentials.localParams.parameter.msg = result.res_data.msg
                }else{
                    credentials.localParams.parameter.transaction_id = ''
                    credentials.localParams.parameter.success = true
                    // credentials.localParams.parameter.congModuleWithdrawal = true
                    credentials.localParams.parameter.withdraw_amount = ''
                    credentials.localParams.parameter.crypto_addess = ''
                }
            }else{
                // console.log('aaaaaaaaaaaaa',result.res_data)
                if(credentials.localParams.params){
                    credentials.localParams.parameter.success = false
                    credentials.localParams.parameter.msg = result.res_data
                    COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
                }else{
                     credentials.localParams.parameter.success = false
                    COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
                }
            }
        }) 
    },
    [Const.RUN_RESEND_EMAIL_LINK]({commit, state,getters,dispatch}, credentials){   
        COMMON._executeApi(Enpoints.EP_RESEND_EMAIL_LINK, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz16','success')
            }else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        })
    },
    [Const.RUN_GET_WITHDRAWAL_DESC]({commit, state,getters,dispatch}, credentials){ 
        COMMON._executeApi(Enpoints.EP_GET_WITHDRAWAL_DESC, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
            if(!error){
                credentials.localParams.parameter.free_margin = result.res_data.margin_detail.freeMargin
                let currencyIcon ={'EUR' : '€','USD' : '$','GBP' : '£','CHF' : 'CHF','JPY' : '¥','AUD': '$'}
                credentials.localParams.parameter.free_margin_currency = result.res_data.margin_detail.freeMargin +' '+ currencyIcon[credentials.localParams.parameter.currencyData]
                if(Object.keys(result.res_data.allowedWithdrawal).length > 0){
                    credentials.localParams.parameter.allowedWithdrawal = result.res_data.allowedWithdrawal
                }else {
                    let json = {} , count = 0
                    let get_withdrawal_method = getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP]
                    for(var key in get_withdrawal_method){
                        count++
                        
                            json[key] = {}
                            let count1 = 0
                            for(var innerkey in get_withdrawal_method[key]){

                                count1++
                                json[key][innerkey] = {}
                                json[key][innerkey][credentials.localParams.parameter.currencyData] = result.res_data.margin_detail.freeMargin
                                
                                if(parseInt(key) != 5){
                                    json[key][innerkey]['allowed'] = '1'
                                }
                            }
                        
                        if(count == Object.keys(get_withdrawal_method).length){
                            credentials.localParams.parameter.allowedWithdrawal = json
                            credentials.localParams.parameter.showBalPanel = false
                        }
                    }
                }

                credentials.localParams.parameter.pay_option = ''
                credentials.localParams.parameter.amount = ''
                credentials.localParams.parameter.avalBalance = ''
                credentials.localParams.parameter.account_number = ''
                credentials.localParams.parameter.submitted = false
            }else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        }) 
    },
    [Const.RUN_GET_WITH_DEPO_CUR_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WITH_DEPO_CUR_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_WITH_DEPO_CUR_LIST, result.walletCurrencyList)
            } else {
                commit(Const.SET_WITH_DEPO_CUR_LIST, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
}
/*
function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') { getToken = '' }
        credentials.localParams.parameter.pageLoader = true

        RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                    credentials.localParams.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            response_array.res_data = data.data
                            callback(false, response_array)
                        } else {
                            if (typeof data.msg == 'object') {
                                response_array.res_data = data.msg.msg
                            } else {
                                response_array.res_data = data.msg
                            }
                            callback(true, response_array)
                        }
                    }
                },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

function _messageDisplayFunction(getParameter, getMessage, msgType) {
    //getParameter.response_msg = getMessage
    //getParameter.msg_type = msgType
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}

function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}*/


// WEBPACK FOOTER //
// ./src/plugins/depositWithdrawal/provider/store-addons/actions.js